<template>
    <a-drawer
            @close="close"
            :visible="addressModal"
            title="选择可配送区域"
            width="70%"
            class="modal"
    >
        <a-row :span="24" type="flex">
            <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" class="item">
                <div class="acea-row row-right row-middle">
                    <a-checkbox v-model="iSselect" @change="allCheckbox">全选</a-checkbox>
                    <span class="empty padding-left-sm" @click="empty">清空</span>
                </div>
            </a-col>
        </a-row>

        <div class="province-container">
            <div
                    v-for="(province, provinceIndex) in provinceList"
                    :key="provinceIndex"
                    class="province-item"
            >
                <div class="province-header">
                    <a-checkbox
                            v-model="province.checked"
                            :disabled="province.disabled"
                            @change="provinceCheckedClick(provinceIndex)"
                    >
                        {{province.areaName}}
                    </a-checkbox>
                    <span class="red">({{ (province.count || 0) + '/' + province.totalDistricts }})</span>
                </div>

                <div class="city-list" v-if="province.checked || activeProvince === provinceIndex">
                    <div
                            v-for="(city, cityIndex) in province.children"
                            :key="cityIndex"
                            class="city-item"
                            @mouseenter="enterCity(provinceIndex, cityIndex)"
                            @mouseleave="leaveCity()"
                    >
                        <a-checkbox
                                v-model="city.checked"
                                :disabled="city.disabled"
                                @change="cityCheckedClick(provinceIndex, cityIndex)"
                                class="city-checkbox"
                        >
                            {{ city.areaName }}
                        </a-checkbox>
                        <span class="red">({{ (city.count || 0) + '/' + (city.children ? city.children.length : 0) }})</span>

                        <div
                                class="district-list"
                                v-if="city.checked || activeCity === `${provinceIndex}-${cityIndex}`"
                        >
                            <a-checkbox
                                    v-for="(district, districtIndex) in city.children || []"
                                    :key="districtIndex"
                                    v-model="district.checked"
                                    :disabled="district.disabled"
                                    class="district-checkbox"
                                    @change="districtCheckedClick(provinceIndex, cityIndex, districtIndex)"
                            >
                                {{ district.areaName }}
                            </a-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="foot-btn">
            <a-button @click="close" class="margin-right-sm">取消</a-button>
            <a-button type="primary" @click="confirm">确定</a-button>
        </div>
    </a-drawer>
</template>

<script>
import * as logistics from '@/api/logistics'
import { mapGetters } from 'vuex'
export default {
    name: 'cityShansong',
    props: {
        type: {
            type: Number,
            default: 1,
        },
        id: {
            type: [Number, String],
            default: 0,
        },
        selectArr: {
            type: Array,
            default: [],
        },
        otherSelectedArr: {
            type: Array,
            default: [],
        }
    },
    data() {
        return {
            iSselect: false,
            addressModal: false,
            activeProvince: -1,
            activeCity: null,
            loading: false,
            provinceList: [],
            totalNum: 0 // 存储所有区的总数
        };
    },
    computed: {
        ...mapGetters(['acityList'])
    },
    watch: {
        addressModal(newVal) {
            if(newVal) {
                this.initData();
            }
        }
    },
    methods: {
        // 初始化数据
        initData() {
            this.provinceList = JSON.parse(JSON.stringify(this.acityList));

            let totalDistrictCount = 0;

            this.provinceList.forEach((province, provinceIndex) => {
                // 初始化省份数据
                this.$set(province, 'checked', false);
                this.$set(province, 'disabled', false);
                this.$set(province, 'count', 0);
                this.$set(province, 'totalDistricts', 0);

                if (province.children && Array.isArray(province.children)) {
                    province.children.forEach((city, cityIndex) => {
                        // 初始化城市数据
                        this.$set(city, 'checked', false);
                        this.$set(city, 'disabled', false);
                        this.$set(city, 'count', 0);

                        if (city.children && Array.isArray(city.children)) {
                            city.children.forEach((district, districtIndex) => {
                                // 初始化区数据
                                this.$set(district, 'checked', false);
                                this.$set(district, 'disabled', false);

                                // 检查是否已选中
                                if (this.selectArr.length > 0) {
                                    this.selectArr.forEach((selectedItem) => {
                                        if (selectedItem.children && Array.isArray(selectedItem.children)) {
                                            selectedItem.children.forEach((selectedCity) => {
                                                if (selectedCity.children && Array.isArray(selectedCity.children)) {
                                                    selectedCity.children.forEach((selectedDistrict) => {
                                                        if (district.areaId == selectedDistrict.areaId) {
                                                            this.$set(district, 'checked', true);
                                                            this.$set(city, 'checked', true);

                                                            // 更新城市计数
                                                            city.count++;

                                                            // 更新省份计数
                                                            province.count++;
                                                        }
                                                    });
                                                }
                                            });
                                        }
                                    });
                                }

                                // 检查是否被其他已选区域占用
                                if(this.otherSelectedArr.length > 0) {
                                    this.otherSelectedArr.forEach((otherItem) => {
                                        if (otherItem.children && Array.isArray(otherItem.children)) {
                                            otherItem.children.forEach((otherCity) => {
                                                if (otherCity.children && Array.isArray(otherCity.children)) {
                                                    otherCity.children.forEach((otherDistrict) => {
                                                        if (district.areaId == otherDistrict.areaId) {
                                                            this.$set(district, 'disabled', true);
                                                            this.$set(city, 'disabled', true);
                                                            this.$set(province, 'disabled', true);
                                                        }
                                                    });
                                                }
                                            });
                                        }
                                    });
                                }

                                // 统计总数
                                if (!district.disabled) {
                                    totalDistrictCount++;
                                }
                                province.totalDistricts++;
                            });
                        }
                    });
                }

                // 设置省份选中状态
                this.$set(province, 'checked', province.count > 0);
            });

            this.totalNum = totalDistrictCount;
        },

        enterCity(provinceIndex, cityIndex) {
            this.activeCity = `${provinceIndex}-${cityIndex}`;
        },

        leaveCity() {
            this.activeCity = null;
        },

        /**
         * 全选或者反选
         */
        allCheckbox() {
            const checked = this.iSselect;

            this.provinceList.forEach(province => {
                if (!province.disabled) {
                    this.$set(province, 'checked', checked);
                    this.$set(province, 'count', 0);

                    if (province.children && Array.isArray(province.children)) {
                        province.children.forEach(city => {
                            if (!city.disabled) {
                                this.$set(city, 'checked', checked);
                                this.$set(city, 'count', 0);

                                if (city.children && Array.isArray(city.children)) {
                                    city.children.forEach(district => {
                                        if (!district.disabled) {
                                            this.$set(district, 'checked', checked);
                                            if (checked) {
                                                city.count++;
                                                province.count++;
                                            }
                                        }
                                    });
                                }
                            }
                        });
                    }
                }
            });
        },

        // 清空
        empty() {
            this.provinceList.forEach(province => {
                this.$set(province, 'checked', false);
                this.$set(province, 'count', 0);

                if (province.children && Array.isArray(province.children)) {
                    province.children.forEach(city => {
                        this.$set(city, 'checked', false);
                        this.$set(city, 'count', 0);

                        if (city.children && Array.isArray(city.children)) {
                            city.children.forEach(district => {
                                this.$set(district, 'checked', false);
                            });
                        }
                    });
                }
            });

            this.iSselect = false;
        },

        /**
         * 点击省
         */
        provinceCheckedClick(provinceIndex) {
            const province = this.provinceList[provinceIndex];

            if (province.checked) {
                // 选中该省下所有城市和区
                let totalCount = 0;

                if (province.children && Array.isArray(province.children)) {
                    province.children.forEach(city => {
                        if (!city.disabled) {
                            this.$set(city, 'checked', true);
                            this.$set(city, 'count', 0);

                            if (city.children && Array.isArray(city.children)) {
                                city.children.forEach(district => {
                                    if (!district.disabled) {
                                        this.$set(district, 'checked', true);
                                        city.count++;
                                        totalCount++;
                                    }
                                });
                            }
                        }
                    });
                }

                this.$set(province, 'count', totalCount);
            } else {
                // 取消选中该省下所有城市和区
                if (province.children && Array.isArray(province.children)) {
                    province.children.forEach(city => {
                        this.$set(city, 'checked', false);
                        this.$set(city, 'count', 0);

                        if (city.children && Array.isArray(city.children)) {
                            city.children.forEach(district => {
                                this.$set(district, 'checked', false);
                            });
                        }
                    });
                }

                this.$set(province, 'count', 0);
                this.iSselect = false;
            }
        },

        /**
         * 点击城市
         */
        cityCheckedClick(provinceIndex, cityIndex) {
            const city = this.provinceList[provinceIndex].children[cityIndex];
            const province = this.provinceList[provinceIndex];

            if (city.checked) {
                // 选中该城市下所有区
                let count = 0;

                if (city.children && Array.isArray(city.children)) {
                    city.children.forEach(district => {
                        if (!district.disabled) {
                            this.$set(district, 'checked', true);
                            count++;
                        }
                    });
                }

                this.$set(city, 'count', count);

                // 更新省份计数
                this.updateProvinceCount(provinceIndex);
                // 更新省份选中状态
                this.updateProvinceCheckState(provinceIndex);
            } else {
                // 取消选中该城市下所有区
                if (city.children && Array.isArray(city.children)) {
                    city.children.forEach(district => {
                        this.$set(district, 'checked', false);
                    });
                }

                this.$set(city, 'count', 0);
                // 更新省份计数
                this.updateProvinceCount(provinceIndex);
                // 更新省份选中状态
                this.updateProvinceCheckState(provinceIndex);
                this.iSselect = false;
            }
        },

        /**
         * 点击区
         */
        districtCheckedClick(provinceIndex, cityIndex, districtIndex) {
            const district = this.provinceList[provinceIndex].children[cityIndex].children[districtIndex];
            const city = this.provinceList[provinceIndex].children[cityIndex];
            const province = this.provinceList[provinceIndex];

            // 更新城市选中状态和计数
            let cityCheckedCount = 0;

            if (city.children && Array.isArray(city.children)) {
                city.children.forEach(d => {
                    if (d.checked && !d.disabled) {
                        cityCheckedCount++;
                    }
                });
            }

            this.$set(city, 'count', cityCheckedCount);
            this.$set(city, 'checked', cityCheckedCount > 0);

            // 更新省份计数和选中状态
            this.updateProvinceCount(provinceIndex);
            this.updateProvinceCheckState(provinceIndex);

            // 检查是否全选
            this.checkAllSelected();
        },

        // 更新省份计数
        updateProvinceCount(provinceIndex) {
            const province = this.provinceList[provinceIndex];
            let provinceCount = 0;

            if (province.children && Array.isArray(province.children)) {
                province.children.forEach(city => {
                    if (city.count) {
                        provinceCount += city.count;
                    }
                });
            }

            this.$set(province, 'count', provinceCount);
        },

        // 更新省份选中状态
        updateProvinceCheckState(provinceIndex) {
            const province = this.provinceList[provinceIndex];

            // 检查省份下是否有被选中的城市
            let hasCheckedCity = false;

            if (province.children && Array.isArray(province.children)) {
                for (const city of province.children) {
                    if (city.checked) {
                        hasCheckedCity = true;
                        break;
                    }
                }
            }

            // 更新省份选中状态
            this.$set(province, 'checked', hasCheckedCity);
        },

        // 检查是否全选
        checkAllSelected() {
            let selectedDistrictCount = 0;
            let allSelected = true;
            let hasDisabled = false;

            this.provinceList.forEach(province => {
                if (province.disabled) {
                    hasDisabled = true;
                }

                if (province.children && Array.isArray(province.children)) {
                    province.children.forEach(city => {
                        if (city.children && Array.isArray(city.children)) {
                            city.children.forEach(district => {
                                if (district.disabled) {
                                    hasDisabled = true;
                                }

                                if (district.checked && !district.disabled) {
                                    selectedDistrictCount++;
                                }

                                if (!district.disabled && !district.checked) {
                                    allSelected = false;
                                }
                            });
                        }
                    });
                }
            });

            if (hasDisabled) {
                allSelected = false;
            }

            this.iSselect = allSelected && selectedDistrictCount > 0;
        },

        // 确定选中的区域
        confirm() {
            const selectList = [];

            this.provinceList.forEach(province => {
                if (province.checked || (province.children && province.children.some(city => city.checked))) {
                    const provinceData = {
                        areaName: province.areaName,
                        areaId: province.areaId,
                        children: [],
                    };

                    if (province.children && Array.isArray(province.children)) {
                        province.children.forEach(city => {
                            if (city.checked || (city.children && city.children.some(district => district.checked))) {
                                const cityData = {
                                    areaName: city.areaName,
                                    areaId: city.areaId,
                                    children: [],
                                };

                                if (city.children && Array.isArray(city.children)) {
                                    city.children.forEach(district => {
                                        if (district.checked) {
                                            cityData.children.push({
                                                areaId: district.areaId,
                                                areaName: district.areaName
                                            });
                                        }
                                    });
                                }

                                if (cityData.children.length > 0) {
                                    provinceData.children.push(cityData);
                                }
                            }
                        });
                    }

                    if (provinceData.children.length > 0) {
                        selectList.push(provinceData);
                    }
                }
            });

            if (selectList.length === 0) {
                this.$message.error('至少选择一个省份或者城市');
                return;
            }

            // 计算选中的区总数
            let selectedDistrictNum = 0;
            selectList.forEach(item => {
                item.children.forEach(city => {
                    selectedDistrictNum += city.children.length;
                });
            });

            let isAllSelect = true;
            if(this.otherSelectedArr.length > 0) {
                isAllSelect = false;
            } else {
                if(selectedDistrictNum != this.totalNum) {
                    isAllSelect = false;
                }
            }

            this.$emit('selectCity', {
                id: this.id,
                selectList: selectList,
                type: this.type, // 0添加 1编辑
                isEdit: this.selectArr.length ? true : false,
                iSselect: isAllSelect
            });

            this.addressModal = false;
            this.provinceList = [];
        },

        close() {
            this.addressModal = false;
            this.provinceList = [];
        }
    }
};
</script>

<style scoped lang="less">
.modal .item {
  margin-bottom: 20px;
}

.province-container {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 10px;
}

.province-item {
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background-color: #fafafa;
}

.province-header {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.city-item {
  margin: 8px 0;
  padding: 8px 15px;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: #fff;
}

.city-checkbox {
  margin-bottom: 8px;
  display: block;
}

.district-list {
  margin-left: 20px;
  padding: 8px;
  background-color: #f0f9ff;
  border: 1px solid #b3d8ff;
  border-radius: 4px;
}

.district-checkbox {
  display: block;
  margin: 5px 0;
}

.red {
  color: #ff0000;
  margin-left: 5px;
}

.empty {
  cursor: pointer;
  color: #1890ff;
}

.foot-btn {
  position: absolute;
  bottom: 0;
  width: calc(100% - 24px);
  padding: 10px 0;
  background-color: #fff;
  border-top: 1px solid #e8e8e8;
}

::v-deep .ant-drawer-body {
  padding-bottom: 70px;
}
</style>



